// Recently Viewed Products
var recentlyViewedProducts = JSON.parse(localStorage.getItem("recentlyViewedProducts"))

if (recentlyViewedProducts) {
  var recentlyViewedProducts = recentlyViewedProducts;
}

document.addEventListener("DOMContentLoaded", (event) => {
  const product_json = document.querySelectorAll("[data-product-json]")
  if( product_json.length != 0 ) {
    var productJson = JSON.parse(
      document.querySelectorAll("[data-product-json]")[0].innerHTML
    );
    
    (function addProductRecentlyView() {
      if (recentlyViewedProducts === null) recentlyViewedProducts = [];
      var product = {
        handle: productJson.handle,
        id: productJson.id,
        url: window.location.pathname,
        title: productJson.title,
        img: productJson.featured_image
      };
      if (JSON.parse(localStorage.getItem("product")) != productJson.handle) {
        localStorage.setItem("product", JSON.stringify(product));
      }
      var productExists = false
      for (var i = recentlyViewedProducts.length; i--;) {
        var curProduct = recentlyViewedProducts[i];
        if (curProduct.handle === product.handle) {
          productExists = true;
          break;
        }
      }
      if (!productExists) {
        recentlyViewedProducts.push(product);
      }
      if (localStorage.getItem(recentlyViewedProducts)) {
        localStorage.getItem("recentlyViewedProducts", JSON.stringify(recentlyViewedProducts));
      } else {
        localStorage.setItem("recentlyViewedProducts", JSON.stringify(recentlyViewedProducts));
      }
    })()
  }
});